import { Icon } from '@iconify/react'
import locationIcon from '@iconify/icons-ph/cloud-rain-duotone'

const Header = () => {
    return (
        <header className="header">
            <h1><Icon icon={locationIcon} /> Severe Storm Tracker (Powered By NASA)</h1>
        </header>
    )
}

export default Header
